<template>
    <svg viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M11.4 11.1801L10.06 10.8801C10.34 8.80007 11.54 7.06007 13.1 6.58007H0.5V5.42007H13.1C11.54 4.94007 10.34 3.20007 10.06 1.12007L11.4 0.820068C11.58 3.72007 13.36 5.22007 15.5 5.42007V6.58007C13.36 6.78007 11.58 8.28007 11.4 11.1801Z"
            fill="var(--btn-color)"
        />
    </svg>
</template>
